module.exports = __webpack_public_path__ + "./images/Seguridad.c87f12562ec77f30edde5a9e28515ede.png";


//////////////////
// WEBPACK FOOTER
// ./websources/public/images/Seguridad.png
// module id = ./websources/public/images/Seguridad.png
// module chunks = 0